import { render } from "./AppleBlack.vue?vue&type=template&id=6d3b745a"
const script = {}

import exportComponent from "../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/AppleBlack.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6d3b745a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6d3b745a', __exports__)) {
    api.reload('6d3b745a', __exports__)
  }
  
  module.hot.accept("./AppleBlack.vue?vue&type=template&id=6d3b745a", () => {
    api.rerender('6d3b745a', render)
  })

}


export default __exports__